<div
  [ngClass]="{ 'has-edit-button': isEditMode }"
  [edsSpacing]="marginBottom === 'auto' ? 'xl' : marginBottom"
>
  <ng-container
    *ngIf="isEditMode"
    [brManageContentButton]="document"
    documentTemplateQuery="new-ImageGrid-document"
    folderTemplateQuery="new-ImageGrid-folder"
    parameter="document"
    [relative]="false"
    root=""
  >
  </ng-container>

  <!-- Has Document -->
  <div
    *ngIf="document && hasContent"
    [ngClass]="{ 'has-edit-button': isEditMode }"
    [class]="!showAsCarousel ? theme : 'logo-carousel-theme'"
  >
    <div edsGrid>
      <div
        class="container image-grid-container"
        [ngClass]="{ 'container--wide': showAsCarousel }"
      >
        <div *ngIf="showAsCarousel" class="row">
          <eds-image-grid
            edsCol
            [images]="images"
            [imageGridLayout]="imageGridLayout"
            [hasLink]="hasLink"
            [imageGridLayoutMobile]="isImageGridLayoutMobile"
            [imageGridLayoutTablet]="isImageGridLayoutTablet"
            [title]="content.titleBlock?.title"
            [subTitle]="content.titleBlock?.subTitle"
            [preTitle]="content.titleBlock?.preTitle"
            [showAsCarousel]="showAsCarousel"
            [sectionTitleTheme]="titleColor"
            [playButtonLabel]="'common.play' | translate"
            [pauseButtonLabel]="'common.pause' | translate"
            [showLogoColorInCarousel]="showLogoColorInCarousel"
          ></eds-image-grid>
        </div>

        <div *ngIf="!showAsCarousel">
          <!--Title  -->
          <div edsRow *ngIf="content.titleBlock?.preTitle">
            <p edsCol class="pre-title" edsSpacing="xs">
              {{ content.titleBlock?.preTitle }}
            </p>
          </div>
          <div *ngIf="content.titleBlock?.title" edsRow>
            <eds-title
              [edsSpacing]="content.paragraphBlock?.content ? 'md' : 'xl'"
              edsCol
              [title]="content.titleBlock.title"
              size="h2"
              [theme]="titleColor"
            ></eds-title>
          </div>
          <!-- Paragraph block -->
          <div *ngIf="content.paragraphBlock?.content" edsRow>
            <div edsCol>
              <div
                *ngIf="content.paragraphBlock.content"
                edsSpacing="xl"
                [innerHTML]="content.paragraphBlock.content"
              ></div>
            </div>
          </div>

          <div edsRow>
            <eds-image-grid
              edsCol
              [images]="images"
              [imageGridLayout]="imageGridLayout"
              [hasLink]="hasLink"
              [imageGridLayoutMobile]="isImageGridLayoutMobile"
              [imageGridLayoutTablet]="isImageGridLayoutTablet"
              [title]="content.edsTitleBlock?.title"
              [subTitle]="content.edsTitleBlock?.subTitle"
              [preTitle]="content.edsTitleBlock?.preTitle"
              [showAsCarousel]="showAsCarousel"
              [playButtonLabel]="'common.play' | translate"
              [pauseButtonLabel]="'common.pause' | translate"
            ></eds-image-grid>
          </div>
        </div>
      </div>
    </div>

    <!-- No Document -->
    <div *ngIf="!document && isEditMode" class="no-document" edsPadding>
      <div edsGrid class="no-document__component">
        <div class="no-document__overlay">
          Click to configure <strong>{{ componentLabel }}</strong>
        </div>
      </div>
    </div>
  </div>
</div>
